/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { logout } from "../../store/modules/AuthStore";
import {
  cleanStore,
  getUserDetails,
  user,
} from "../../store/modules/UserStore";
import { request } from "../../store/modules/RequestStore";

import { useGlobalContext } from "../../context";

//Tooltip
import Tooltip from "../widgets/Tooltip";

import {
  Navbar,
  NavLogo,
  NavRight,
  ProfileGrid,
  ProfileSquare,
  ProfileText,
  CustomHeader,
  DropDownBtn,
  MenuIcon,
  DropdownMenu,
} from "./StyledComponents/NavbarElements";

import { links } from "./data/navlinks";

import logoHorizontal from "../../assets/images/logohorizontal.png";
import { useTranslation } from "react-i18next";
// import TranslationApp from "../Multilanguage/TranslationApp";

const Header = () => {
  const dispatch = useDispatch();
  const configurationSelf = useSelector(request);

  const { t } = useTranslation();

  const hiddenButton = () => {
    if (
      configurationSelf.selfServiceConfiguration.activateNewRequest === false
    ) {
      links[2].tooltipTitle = "Market Place";
      links[2].destination = "/MarketPlace/index";
    } else {
      links[2].tooltipTitle = "tooltips.createRequest";
      links[2].destination = "/request/new";
    }
  };

  const userDetails = useSelector(user);
  const [profileMenuActive, setProfileMenuActive] = useState(false);

  // pathname state
  const pathname = useLocation().pathname;

  //   const [languageActive, setLanguageActive] = useState("es");

  const { currentRequestID, setIsDropdwonActive, isDropdownActive } =
    useGlobalContext();

  const handleLogout = (e: any) => {
    e.preventDefault();
    dispatch(logout());
  };

  hiddenButton();

  useEffect(() => {
    if (!localStorage.userdata) dispatch(getUserDetails());
    return () => {
      dispatch(cleanStore());
    };
  }, []);

  //   const handleLanguage = (e: any) => {
  //     e.preventDefault();
  //     setMenuActive((prev) => {
  //       return !prev;
  //     });
  //   };

  //   const handleChangeLanguage = (e: any, language: string) => {
  //     e.preventDefault();
  //     setMenuActive((prev) => {
  //       return !prev;
  //     });
  //     setLanguageActive(language);
  //   };

  const handleProfileMenu = (e: any) => {
    e.preventDefault();
    setProfileMenuActive((prev) => {
      return !prev;
    });
  };

  const ProfileMenu = () => {
    if (profileMenuActive) {
      return (
        <div className="absolute w-auto top-11 bg-white border rounded shadow-xl z-1000">
          <hr />
          <button
            className="transition-colors duration-200 px-4 py-2 hover:bg-purple-100 w-full"
            onClick={(e) => handleLogout(e)}
          >
            <span className="text-sm flex w-full items-center justify-center font-semibold">
              {t("logout")}
            </span>
          </button>
          <hr />
        </div>
      );
    }
    return <div></div>;
  };

  return (
    <CustomHeader isDropdownActive={isDropdownActive}>
      <Navbar>
        <div className="flex w-4/10">
          <NavLogo to="/">
            <img
              style={{ height: "40px" }}
              src={
                userDetails.CompanyImage ||
                "https://helppeoplecloud.com/wp-content/uploads/2021/11/Logo-helppeople-2021-horizontal.png"
              }
              alt=""
              onError={(e: any) => {
                e.target.src =
                  "https://helppeoplecloud.com/wp-content/uploads/2021/11/Logo-helppeople-2021-horizontal.png";
              }}
            />
          </NavLogo>
        </div>

        {/* <MultiLanguageButton /> */}

        <NavRight>
          <div className="flex flex-col md:grid md:grid-cols-3 md:gap-4 justify-items-center items-center gap-6">
            {links.map((link, index) => {
              const {
                tooltipTitle,
                destination,
                logo: { Component, color, size, fillColor },
              } = link;

              const fill = destination === pathname;
              const onRequestDetail =
                `/request/${currentRequestID}` === pathname;

              return (
                <Tooltip title={t(tooltipTitle)} key={index} navbar>
                  {destination === "/request/all" ? (
                    <NavLink
                      exact
                      to={destination}
                      activeClassName={"active-route"}
                      className={onRequestDetail ? "active-route" : ""}
                    >
                      <Component
                        size={size}
                        color={fill || onRequestDetail ? fillColor : color}
                        fill={fill || (onRequestDetail && fillColor)}
                      />
                    </NavLink>
                  ) : (
                    <NavLink
                      exact
                      to={destination}
                      activeClassName={"active-route"}
                    >
                      <Component
                        size={size}
                        color={fill ? fillColor : color}
                        fill={fill && fillColor}
                      />
                    </NavLink>
                  )}
                </Tooltip>
              );
            })}
          </div>
          <ProfileSquare
            className="cursor-pointer"
            onClick={(e: any) => handleProfileMenu(e)}
          >
            <ProfileGrid>
              <div className="w-full h-full flex flex-col items-end justify-center">
                <ProfileText className="font-title">{`${userDetails.name} ${userDetails.lastName}`}</ProfileText>
                {/* <ProfileText className="text-azulMedio">{`${userDetails.companyName}`}</ProfileText> */}
              </div>
              <div className="w-full h-full flex flex-col items-start justify-center">
                {userDetails.userImage === "" ? (
                  <img
                    className={`rounded-full border-2 ${
                      userDetails.isVIP === "1"
                        ? "border-amarillo"
                        : "border-white"
                    } bg-white w-11 h-11`}
                    alt="profile"
                    src={`https://avatar.oxro.io/avatar.svg?name=${
                      userDetails.name
                    }+${userDetails.lastName.replace(
                      / /g,
                      ""
                    )}&background=4D6AEF&length=2`}
                  />
                ) : (
                  <div className="relative">
                    <img
                      className={`rounded-full border-4 ${
                        userDetails.isVIP === "1"
                          ? "border-amarillo"
                          : "border-white"
                      } bg-white w-11 h-11`}
                      src={`data:${userDetails.userImageMime};base64,${userDetails.userImage}`}
                      alt="profile"
                    />
                    {userDetails.isVIP === "1" && (
                      <div className="absolute bottom-0 right-0 h-5 rounded-full bg-yellow-400 flex justify-center items-center p-1">
                        <svg
                          className="fill-current h-3"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512.002 512.002"
                        >
                          <path d="M511.267 197.258a14.995 14.995 0 00-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 00-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 00-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0021.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0021.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 003.795-15.375z" />
                        </svg>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </ProfileGrid>
            <ProfileMenu />
          </ProfileSquare>
        </NavRight>
        {/* <MultiLanguageButton /> */}
        {isDropdownActive && (
          <DropdownMenu>
            <div className="flex flex-col gap-12 md:grid md:grid-cols-3 md:gap-4 justify-items-center items-center">
              {links.map((link, index) => {
                const {
                  tooltipTitle,
                  destination,
                  logo: { Component, color, size, fillColor },
                } = link;

                const fill = destination === pathname;
                const onRequestDetail =
                  `/request/${currentRequestID}` === pathname;

                return (
                  <Tooltip title={tooltipTitle} key={index} navbar>
                    {destination === "/request/all" ? (
                      <NavLink
                        exact
                        to={destination}
                        activeClassName={"active-route"}
                        className={onRequestDetail ? "active-route" : ""}
                        onClick={() => {
                          setIsDropdwonActive(false);
                        }}
                      >
                        <Component
                          size={size}
                          color={fill || onRequestDetail ? fillColor : color}
                          fill={fill || (onRequestDetail && fillColor)}
                        />
                      </NavLink>
                    ) : (
                      <NavLink
                        exact
                        to={destination}
                        activeClassName={"active-route"}
                        onClick={() => {
                          setIsDropdwonActive(false);
                        }}
                      >
                        <Component
                          size={size}
                          color={fill ? fillColor : color}
                          fill={fill && fillColor}
                        />
                      </NavLink>
                    )}
                  </Tooltip>
                );
              })}
            </div>
            <ProfileSquare
              className="cursor-pointer"
              onClick={(e: any) => handleProfileMenu(e)}
            >
              <ProfileGrid>
                <div className="w-full h-full flex flex-col items-end">
                  <ProfileText className="font-title">{`${userDetails.name} ${userDetails.lastName}`}</ProfileText>
                  <ProfileText className="text-azulMedio">{`${userDetails.companyName}`}</ProfileText>
                </div>
                <div className="w-full h-full flex flex-col items-start justify-center">
                  {userDetails.userImage === "" ? (
                    <img
                      className={`rounded-full border-2 ${
                        userDetails.isVIP === "1"
                          ? "border-amarillo"
                          : "border-white"
                      } bg-white w-11 h-11`}
                      alt="profile"
                      src={`https://avatar.oxro.io/avatar.svg?name=${
                        userDetails.name
                      }+${userDetails.lastName.replace(
                        / /g,
                        ""
                      )}&background=4D6AEF&length=2`}
                    />
                  ) : (
                    <div className="relative">
                      <img
                        className={`rounded-full border-4 ${
                          userDetails.isVIP === "1"
                            ? "border-amarillo"
                            : "border-white"
                        } bg-white w-11 h-11`}
                        src={`data:${userDetails.userImageMime};base64,${userDetails.userImage}`}
                        alt="profile"
                      />
                      {userDetails.isVIP === "1" && (
                        <div className="absolute bottom-0 right-0 h-5 rounded-full bg-yellow-400 flex justify-center items-center p-1">
                          <svg
                            className="fill-current h-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512.002 512.002"
                          >
                            <path d="M511.267 197.258a14.995 14.995 0 00-12.107-10.209l-158.723-23.065-70.985-143.827a14.998 14.998 0 00-26.901 0l-70.988 143.827-158.72 23.065a14.998 14.998 0 00-8.312 25.585l114.848 111.954-27.108 158.083a14.999 14.999 0 0021.763 15.812l141.967-74.638 141.961 74.637a15 15 0 0021.766-15.813l-27.117-158.081 114.861-111.955a14.994 14.994 0 003.795-15.375z" />
                          </svg>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </ProfileGrid>
              <ProfileMenu />
            </ProfileSquare>
          </DropdownMenu>
        )}
        <DropDownBtn onClick={() => setIsDropdwonActive(!isDropdownActive)}>
          <MenuIcon />
        </DropDownBtn>
      </Navbar>
    </CustomHeader>
  );
};

export default Header;
